/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OemRateEntryDto
 */
export interface OemRateEntryDto {
    /**
     * 
     * @type {string}
     * @memberof OemRateEntryDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof OemRateEntryDto
     */
    windowValue: number;
    /**
     * 
     * @type {string}
     * @memberof OemRateEntryDto
     */
    windowUnit: OemRateEntryDtoWindowUnitEnum;
    /**
     * 
     * @type {number}
     * @memberof OemRateEntryDto
     */
    costAmount: number;
    /**
     * 
     * @type {string}
     * @memberof OemRateEntryDto
     */
    currency: string;
    /**
     * 
     * @type {number}
     * @memberof OemRateEntryDto
     */
    sortOrder: number;
}


/**
 * @export
 */
export const OemRateEntryDtoWindowUnitEnum = {
    Day: 'day',
    Hour: 'hour'
} as const;
export type OemRateEntryDtoWindowUnitEnum = typeof OemRateEntryDtoWindowUnitEnum[keyof typeof OemRateEntryDtoWindowUnitEnum];


/**
 * Check if a given object implements the OemRateEntryDto interface.
 */
export function instanceOfOemRateEntryDto(value: object): value is OemRateEntryDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('windowValue' in value) || value['windowValue'] === undefined) return false;
    if (!('windowUnit' in value) || value['windowUnit'] === undefined) return false;
    if (!('costAmount' in value) || value['costAmount'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    return true;
}

export function OemRateEntryDtoFromJSON(json: any): OemRateEntryDto {
    return OemRateEntryDtoFromJSONTyped(json, false);
}

export function OemRateEntryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OemRateEntryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'windowValue': json['windowValue'],
        'windowUnit': json['windowUnit'],
        'costAmount': json['costAmount'],
        'currency': json['currency'],
        'sortOrder': json['sortOrder'],
    };
}

export function OemRateEntryDtoToJSON(json: any): OemRateEntryDto {
    return OemRateEntryDtoToJSONTyped(json, false);
}

export function OemRateEntryDtoToJSONTyped(value?: OemRateEntryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'windowValue': value['windowValue'],
        'windowUnit': value['windowUnit'],
        'costAmount': value['costAmount'],
        'currency': value['currency'],
        'sortOrder': value['sortOrder'],
    };
}

